import { uploadComponent } from './file-upload.component';
import { UploadService } from './file-upload.service';
import { UploadFileTypes } from './file-upload.constants';
import { UploadFileModel } from './file-upload-model.directive';
import uploadSummary from './summary/file-upload-summary';

export default angular
  .module('ng1-file-upload', [uploadSummary])
  .component('fdFileUpload', uploadComponent)
  .constant('uploadFileTypes', UploadFileTypes)
  .service('uploadService', UploadService)
  .directive('uploadFileModel', UploadFileModel)
  .name;

